import React, { useState } from 'react';
import { CheckCircle2, AlertTriangle, FileCheck2 } from 'lucide-react';
import { NachweisKnopf } from '../rechtstexte/RechtstexteNachweis';

const dt = (iso) => { if (!iso) return '—'; try { return new Date(iso).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' }); } catch { return iso; } };

const Status = ({ s }) => {
  if (s.status === 'offen') return <span className="inline-flex items-center gap-1 text-amber-700" data-testid={`rt-status-${s.doc}`}><AlertTriangle className="w-3.5 h-3.5" />offen{s.erstzugang ? ' · wird beim ersten Login abgefragt' : ' · neue Fassung'}{s.letzte ? ` (zuletzt bestätigt am ${dt(s.letzte.am)} · ${s.letzte.geraet})` : ''}</span>;
  if (s.status === 'unbekannt') return <span className="text-gray-500" data-testid={`rt-status-${s.doc}`}>keine Bestätigung gespeichert</span>;
  if (s.status === 'erfassungsbogen') return <span className="inline-flex items-center gap-1 text-emerald-700" data-testid={`rt-status-${s.doc}`}><FileCheck2 className="w-3.5 h-3.5" />im Erfassungsbogen bestätigt</span>;
  return <span className="inline-flex items-center gap-1 text-emerald-700" data-testid={`rt-status-${s.doc}`}><CheckCircle2 className="w-3.5 h-3.5" />bestätigt am {dt(s.letzte.am)} · {s.letzte.geraet}</span>;
};

export const RechtstexteStand = ({ rt, testId, pdf, name }) => {
  const [offen, setOffen] = useState(false);
  if (!rt) return null;
  return (
    <div className="sm:col-span-2 mt-2 border-t border-gray-100 pt-2" data-testid={testId}>
      <div className="flex items-center gap-3 mb-1"><p className="text-[10px] tracking-[0.18em] uppercase text-[#b8893d]">AGB &amp; Datenschutz</p>
        {pdf && <NachweisKnopf pfad={pdf} name={name} testId={`${testId}-pdf`} />}</div>
      <ul className="space-y-0.5">
        {rt.status.map((s) => <li key={s.doc} className="flex flex-wrap gap-x-2"><span className="font-medium text-[#1B3A5C] min-w-[10rem]">{s.doc === 'agb' ? 'AGB' : 'Datenschutzerklärung'}</span><Status s={s} /></li>)}
      </ul>
      {rt.verlauf.length > 0 && <button type="button" onClick={() => setOffen(!offen)} aria-expanded={offen} className="mt-1 text-[#b8893d] hover:underline" data-testid={`${testId}-verlauf-toggle`}>{offen ? 'Verlauf ausblenden' : `Verlauf anzeigen (${rt.verlauf.length})`}</button>}
      {offen && (
        <ul className="mt-1 divide-y divide-gray-100 border border-gray-100 rounded-lg bg-white" data-testid={`${testId}-verlauf`}>
          {rt.verlauf.map((v, i) => (
            <li key={i} className="px-2.5 py-1.5 grid sm:grid-cols-[8.5rem_1fr] gap-x-3" data-testid={`${testId}-verlauf-${i}`}>
              <span className="text-gray-500">{dt(v.am)}</span>
              <span><b className="text-[#1B3A5C]">{v.doc === 'agb' ? 'AGB' : 'Datenschutz'}</b>{v.stand ? ` · Stand ${v.stand}` : ''} · <span title={`Version ${v.version}`}>{v.anlass}</span><br /><span className="text-gray-500">Gerät: {v.geraet} · IP {v.ip}</span></span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
